import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiConfig} from '../../../shared/services/api/config.api';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiResponse} from '../../../shared/types/api-response.type'
import {GENERAL_CONSTANTS} from '../../../shared/constants/constant';
import {SERVICE_CONSTANTS, API_CONSTANTS} from '../../../shared/constants/apiConstant';
import {RiskProfileRequest} from 'app/ppm-app/shared/types/risk-profile.type';

@Injectable()
export class RiskProfileService {
  private readonly baseUrl: string = ApiConfig.baseURL + SERVICE_CONSTANTS.WEB_SERVICE + GENERAL_CONSTANTS.SLASH;

  constructor(private readonly http: HttpClient) {}

  public loadLocale(language: string): Observable<any> {
    const localeUrl = `assets/i8tn/ppm/${language}.json`;
    return this.http.get(localeUrl);
  }

  public submitRiskProfile(token: string, body: RiskProfileRequest): Observable<ApiResponse> {
    const headers = new HttpHeaders({
      Authorization: token
    });

    const url = this.baseUrl + API_CONSTANTS.SAVE_RISK_PROFILE;

    return this.http.post<ApiResponse>(url, body, { headers: headers });
  }
}
